import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import YearStatement from './YearStatement';

export default function ListStatement({ yearStatements }) {
  return (
    <Stack
      direction="column"
      spacing="16px"
    >
      {yearStatements.map(({ year, statements }) => (
        <YearStatement
          key={year}
          statements={statements}
          year={year}
        />
      ))}
    </Stack>
  );
}

ListStatement.propTypes = {
  yearStatements: PropTypes.arrayOf(
    PropTypes.shape({
      year: PropTypes.string.isRequired,
      statements: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          month: PropTypes.string.isRequired,
          last4Digits: PropTypes.string.isRequired,
          unitAccountId: PropTypes.string.isRequired
        })
      ).isRequired
    })
  ).isRequired
};
